<template>
    <teleport to="body">
        <div
            v-if="prompt !== null"
            class="fixed inset-0 z-[700] flex items-center justify-center bg-black/30 p-4"
            @click.self="$emit('close')"
        >
            <div class="w-full max-w-md rounded-xl bg-white p-6 shadow-xl">
                <h3 class="text-lg font-medium text-gray-800">
                    {{ t("vue.ai_chat_cap_target_title") }}
                </h3>
                <p class="mt-2 text-sm text-gray-500">
                    {{ t("vue.ai_chat_cap_target_message") }}
                </p>

                <p
                    class="mt-4 rounded-lg bg-gray-50 px-3 py-2 text-sm italic text-gray-600"
                >
                    {{ prompt }}
                </p>

                <div class="mt-6 flex flex-wrap justify-end gap-3">
                    <AtomicButton
                        color="colorless"
                        size="sm"
                        @click="$emit('close')"
                    >
                        {{ t("vue.cancel") }}
                    </AtomicButton>
                    <AtomicButton
                        color="white"
                        size="sm"
                        @click="$emit('choose', 'new')"
                    >
                        {{ t("vue.ai_chat_cap_target_new") }}
                    </AtomicButton>
                    <AtomicButton
                        color="yellow"
                        size="sm"
                        @click="$emit('choose', 'current')"
                    >
                        {{ t("vue.ai_chat_cap_target_current") }}
                    </AtomicButton>
                </div>
            </div>
        </div>
    </teleport>
</template>

<script lang="ts" setup>
import { useTranslations } from "@/composables/useTranslations";
import type { AiCapabilityTarget } from "@/types/AiChat/IAiChat";

const { t } = useTranslations();

withDefaults(defineProps<{ prompt?: string | null }>(), { prompt: null });

defineEmits<{
    (event: "choose", target: AiCapabilityTarget): void;
    (event: "close"): void;
}>();
</script>
